var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollInfinite",style:(_vm.scrollStyle),attrs:{"id":"scrollInfinite"}},[(_vm.scrollInfiniteForTable)?_c('div',{ref:"forTable",staticClass:"forTableDiv"}):_vm._e(),_vm._t("body",function(){return [_vm._m(0)]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"defaultLoading--icon"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }